import { fetchAPIWithID } from "../config";

export async function getStanding(id) {
  let req = {};
  req.Guid = id;
  const data = await fetchAPIWithID("/ssm_api_node/getstanding", req);
  let response = JSON.parse(data.Data);
  return response;
}
